import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { pixelService, IPixel } from 'services/PixelService';
import LegacyPixel from 'components/Pixel/LegacyPixel';
import { PIXEL_URL } from 'settings';

interface IState extends IStateBase {
  hasLegacy: boolean;
  addAffiliatePixel: string;
  pixel: IPixel;
}

export default class Pixel extends BaseComponent<IState> {
  state = {
    hasLegacy: false,
    addAffiliatePixel: '',
    pixel: {
      facebook: '',
      analytics: '',
      adwords: '',
      taboola: '',
      outbrain: '',
      tagmanager: '',
    }
  };

  componentDidMount() {
    pixelService
      .init()
      .bindComponent(this)
      .filter((pixel) => {
        /*
          hasLegacy: Should be removed in not too distance future
        */

        const values = Object.values(pixel).filter((value) => value !== null);

        if (values.length === 0) {
          this.setState({ hasLegacy: true });

          return false;
        }

        return true;
      })
      .subscribe(pixel => {

        if (pixel.analytics) {
          this.scriptPixel('ANALYTICS_PIXEL_SCRIPT', pixel.analytics);
        }

        if (pixel.tagmanager) {
          this.scriptPixel('TAGMANAGER_PIXEL_SCRIPT', pixel.tagmanager);
        }

        this.setState({ pixel });
      });

    pixelService
      .setAffiliationCookie()
      .bindComponent(this)
      .subscribe(addAffiliatePixel => {
        this.setState({ addAffiliatePixel });
      });
  }

  framePixel = (id: string, src: string) => {
    let elementFrame = document.getElementById(id);

    if (!elementFrame) {
      elementFrame = document.createElement('iframe');
      elementFrame.setAttribute('id', id);
      elementFrame.setAttribute('style', 'width: 0; height: 0; border: 0; opacity: 0;');
    }

    elementFrame.setAttribute('src', `${PIXEL_URL}/render/pixel?hash=${src}`);

    document.body.appendChild(elementFrame);
  };

  scriptPixel = (id: string, script: any) => {
    if (script.head) {
      let newHeadElementScript;
      let headElementScript = document.getElementById(`${id}_HEAD`);

      if (!headElementScript) {
        newHeadElementScript = document.createElement('script');
        newHeadElementScript.setAttribute('id', `${id}_HEAD`);

        if (headElementScript !== newHeadElementScript) {
          headElementScript = newHeadElementScript;
        }
      }

      document.head.appendChild(headElementScript);
      headElementScript.innerHTML = script.head;
    }

    let bodyElementScript = document.createElement('script');

    bodyElementScript.innerHTML = script.body;

    document.body.appendChild(bodyElementScript);
  };

  render() {
    const { hasLegacy, addAffiliatePixel, pixel } = this.state;

    return (
      <div id='pixel-container' style={{width: '1px', height: '1px'}}>
        {!hasLegacy ?

          <React.Fragment>
            {
              addAffiliatePixel &&
              <iframe id='pixel-mark-affiliate' src={addAffiliatePixel} width='1' height='1' frameBorder='0' />
            }
            {
              pixel.facebook &&
              <iframe id='FACEBOOK_PIXEL_SCRIPT' src={`${PIXEL_URL}/render/pixel?hash=${pixel.facebook}`} width='1' height='1' frameBorder='0' />
            }
            {
              pixel.adwords &&
              <iframe id='ADWORDS_PIXEL_SCRIPT' src={`${PIXEL_URL}/render/pixel?hash=${pixel.adwords}`} width='1' height='1' frameBorder='0' />
            }
            {
              pixel.taboola &&
              <iframe id='TABOOLA_PIXEL_SCRIPT' src={`${PIXEL_URL}/render/pixel?hash=${pixel.taboola}`} width='1' height='1' frameBorder='0' />
            }
            {
              pixel.outbrain &&
              <iframe id='OUTBRAIN_PIXEL_SCRIPT' src={`${PIXEL_URL}/render/pixel?hash=${pixel.outbrain}`} width='1' height='1' frameBorder='0' />
            }
          </React.Fragment> :
          <LegacyPixel />
        }
      </div>
    );
  }
}
